import { ClientSurveyLink } from "app/AppRouter/links"
import { Footer, Layout } from "components"
import { PageHeader } from "components/Header/PageHeader"
import { ClientProvider } from "modules/ClientAuthorization/common/ClientContext"
import { Img } from "ui-kit/components-branded/index"
import { getRootPath } from "utils/utils"

export function BadIllustration() {
    return (
        <Img className="bad-illustration" src="error-illustration.svg" width={296} height={168} />
    )
}

export function NotFoundPage() {
    return (
        <Layout className="profile">
            <ClientProvider>
                <PageHeader />
                <section className="not-found-page">
                    <BadIllustration />
                    <div>
                        <div className="not-found-page__headline">
                            Такой страницы нет, но есть психологи
                        </div>
                    </div>
                    <div className="not-found-page__buttons">
                        <ClientSurveyLink className="booking__primary-button transition-ease booking-cards__not-available-button--hover">
                            Подобрать психолога
                        </ClientSurveyLink>
                        <a
                            href={getRootPath()}
                            className="border-radius-5 py-3 px-5 text-center b-button button--regular w-100 not-found-page__secondary-button transition-ease"
                        >
                            Перейти на главную
                        </a>
                    </div>
                </section>
                <Footer />
            </ClientProvider>
        </Layout>
    )
}
